import { type RouteObject } from "react-router-dom"

const routes: RouteObject = {
  path: "onboarding",
  lazy: async () => {
    const { default: Protected } = await import("@/modules/onboarding/components/protected")
    return { Component: Protected }
  },
  children: [
    {
      index: true,
      lazy: async () => {
        const { default: OnboardingPage } = await import("@/pages/onboarding")
        return { Component: OnboardingPage }
      },
    },
    {
      path: "spoken",
      lazy: async () => {
        const { default: OnboardingSpokenPage } = await import("@/pages/onboarding/spoken")
        return { Component: OnboardingSpokenPage }
      },
    },
    {
      path: "not-spoken",
      lazy: async () => {
        const { default: OnboardingNotSpokenPage } = await import("@/pages/onboarding/not-spoken")
        return { Component: OnboardingNotSpokenPage }
      },
    },
  ],
}

export default routes
